import React from "react";
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Poppers from "@material-ui/core/Popper";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/icons/Menu";
import Drawer from "@material-ui/core/Drawer";

// @material-ui/icons
import Person from "@material-ui/icons/Person";
// core components
import Button from "../../components/CustomButtons/Button.js";

import { logout } from "../../api/apiUser.js";
import { useHistory } from "react-router-dom";

import styles from "../../assets/jss/material-dashboard-react/components/headerLinksStyle.js";
import { isAuthenticated } from "../../utils/authService";
import { Hidden, ListItemText } from "@material-ui/core";

const useStyles = makeStyles(styles);

export default function AdminNavbarLinks() {
  const history = useHistory(); // Initialize useHistory hook

  const classes = useStyles();
  const [openCriteria, setOpenCriteria] = React.useState(null);
  const [openProfile, setOpenProfile] = React.useState(null);
  const [openDrawer, setOpenDrawer] = React.useState(false); // Drawer state

  const handleDrawerToggle = () => {
    setOpenDrawer(!openDrawer);
  };

  const handleClickProfile = (event) => {
    if (openProfile && openProfile.contains(event.target)) {
      setOpenProfile(null);
    } else {
      setOpenProfile(event.currentTarget);
    }
  };

  const handleClickCriteria = (event) => {
    if (openCriteria && openCriteria.contains(event.target)) {
      setOpenCriteria(null);
    } else {
      setOpenCriteria(event.currentTarget);
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
      history.push("/admin/dashboard");
    } catch (error) {
      console.error(error);
    }
    handleCloseProfile();
  };

  const handleCloseCriteria = () => {
    setOpenCriteria(null);
  };

  const handleCloseProfile = () => {
    setOpenProfile(null);
  };

  return (
    <>
      <Hidden mdUp implementation="css">
        <IconButton
          color="inherit"
          aria-label="open-drawer"
          onClick={handleDrawerToggle}
        >
          <Menu />
        </IconButton>

        {/* Drawer for vertical menu */}
        <Drawer anchor="left" open={openDrawer} onClose={handleDrawerToggle}>
          <div
            className={classes.drawerList}
            role="presentation"
            onClick={handleDrawerToggle}
            onKeyDown={handleDrawerToggle}
          >
            <List>
              <ListItem button component="a" href="/admin/inputData">
                <ListItemText primary="Unos podataka" />
              </ListItem>
              <ListItem button component="a" href="/admin/importData">
                <ListItemText primary="Import podataka" />
              </ListItem>
              <ListItem button component="a" href="/admin/showallcriteria">
                <ListItemText primary="Prikaz svih kriterijuma" />
              </ListItem>
              {isAuthenticated() && (
                <>
                  <ListItem button component="a" href="/admin/createcriteria">
                    <ListItemText primary="Dodavanje kriterijuma" />
                  </ListItem>
                  <ListItem button component="a" href="/admin/editcriteria">
                    <ListItemText primary="Izmjene svih kriterijuma" />
                  </ListItem>
                </>
              )}
            </List>
            <Divider />
            {isAuthenticated() ? (
              <List>
                <ListItem button onClick={handleLogout}>
                  <ListItemText primary="Odjava" />
                </ListItem>
              </List>
            ) : (
              <List>
                <ListItem button component="a" href="/admin/login">
                  <ListItemText primary="Prijava" />
                </ListItem>
              </List>
            )}
          </div>
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        <div className={classes.w100}>
          <div className={[classes.manager, classes.w100]}>
            <div className={[classes.container, classes.w100]}>
              <div className={classes.left}>
                <List className={classes.list}>
                  <ListItem className={classes.inlineBlock}>
                    <a href="/admin/inputData" className={classes.block}>
                      Unos podataka
                    </a>
                  </ListItem>
                  <ListItem className={classes.inlineBlock}>
                    <a href="/admin/importData" className={classes.block}>
                      Import podataka
                    </a>
                  </ListItem>
                  <ListItem
                    className={classes.inlineBlock}
                    onClick={handleClickCriteria}
                  >
                    <a
                      href="/admin/showallcriteria"
                      className={classes.block}
                      onClick={(e) => e.preventDefault()}
                    >
                      Kriterijumi
                    </a>
                    <Poppers
                      open={Boolean(openCriteria)}
                      anchorEl={openCriteria}
                      transition
                      disablePortal
                      className={
                        classNames({ [classes.popperClose]: !openCriteria }) +
                        " " +
                        classes.popperNav
                      }
                    >
                      {({ TransitionProps, placement }) => (
                        <Grow
                          {...TransitionProps}
                          id="profile-menu-list-grow"
                          style={{
                            transformOrigin:
                              placement === "bottom"
                                ? "center top"
                                : "center bottom",
                          }}
                        >
                          <Paper>
                            <ClickAwayListener
                              onClickAway={handleCloseCriteria}
                            >
                              <MenuList role="menu">
                                <MenuItem className={classes.dropdownItem}>
                                  <a href="/admin/showallcriteria">
                                    Prikaz svih kriterijuma
                                  </a>
                                </MenuItem>
                                {isAuthenticated() && (
                                  <MenuItem className={classes.dropdownItem}>
                                    <a href="/admin/createcriteria">
                                      Dodavanje kriterijuma
                                    </a>
                                  </MenuItem>
                                )}
                                {isAuthenticated() && (
                                  <MenuItem className={classes.dropdownItem}>
                                    <a href="/admin/editcriteria">
                                      Izmjene svih kriterijuma
                                    </a>
                                  </MenuItem>
                                )}
                              </MenuList>
                            </ClickAwayListener>
                          </Paper>
                        </Grow>
                      )}
                    </Poppers>
                  </ListItem>
                </List>
              </div>
              <div className={classes.right}>
                {isAuthenticated() && (
                  <>
                    <div className={classes.user}>
                      <Button
                        color={window.innerWidth > 959 ? "success" : "success"}
                        justIcon={window.innerWidth > 959}
                        simple={!(window.innerWidth > 959)}
                        aria-owns={
                          openProfile ? "profile-menu-list-grow" : null
                        }
                        aria-haspopup="true"
                        onPress={handleClickProfile}
                        className={classes.buttonLink}
                      >
                        <Person className={classes.icons} />
                      </Button>
                      <p className={classes.name}>
                        {localStorage.getItem("ime") +
                          " " +
                          localStorage.getItem("prezime")}
                      </p>
                    </div>

                    <Poppers
                      open={Boolean(openProfile)}
                      anchorEl={openProfile}
                      transition
                      disablePortal
                      className={
                        classNames({ [classes.popperClose]: !openProfile }) +
                        " " +
                        classes.popperNav
                      }
                    >
                      {({ TransitionProps, placement }) => (
                        <Grow
                          {...TransitionProps}
                          id="profile-menu-list-grow"
                          style={{
                            transformOrigin:
                              placement === "bottom"
                                ? "center top"
                                : "center bottom",
                          }}
                        >
                          <Paper>
                            <ClickAwayListener onClickAway={handleCloseProfile}>
                              <MenuList role="menu">
                                <Divider light />
                                <MenuItem
                                  onClick={handleLogout}
                                  className={classes.dropdownItem}
                                >
                                  Odjava
                                </MenuItem>
                              </MenuList>
                            </ClickAwayListener>
                          </Paper>
                        </Grow>
                      )}
                    </Poppers>
                  </>
                )}
                {!isAuthenticated() && (
                  <>
                    <a href="/admin/login" className={classes.name}>
                      <Button
                        color={window.innerWidth > 959 ? "success" : "success"}
                        justIcon={window.innerWidth > 959}
                        simple={!(window.innerWidth > 959)}
                        aria-owns={
                          openProfile ? "profile-menu-list-grow" : null
                        }
                        aria-haspopup="true"
                        className={classes.buttonLink}
                      >
                        <Person className={classes.icons} />
                      </Button>
                      Prijava
                    </a>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </Hidden>
    </>
  );
}
